module.exports = __webpack_public_path__ + "static/unt-e4321a91f1873c1179fc53a2f4d8b6f1.png";